import type { MetadataFilter } from "@/types/MetadataFilter"

export const CONVERSATION_SEARCH_TYPE = {
  ALL_FIELDS: "ALL_FIELDS",
  SIMULATION_OUTPUT_ID: "SIMULATION_OUTPUT_ID",
  AGENT_ID: "AGENT_ID",
  CUSTOMER_METADATA: "CUSTOMER_METADATA",
  RUN_STATUS: "RUN_STATUS",
} as const

export type ConversationSearchType =
  (typeof CONVERSATION_SEARCH_TYPE)[keyof typeof CONVERSATION_SEARCH_TYPE]

export const UPLOADED_CONVERSATION_METRIC_OUTPUT_TYPE = {
  STRING: "string",
  FLOAT: "float",
  SET: "set",
} as const

export type ConversationsMetricOutputType =
  (typeof UPLOADED_CONVERSATION_METRIC_OUTPUT_TYPE)[keyof typeof UPLOADED_CONVERSATION_METRIC_OUTPUT_TYPE]

export const UPLOADED_CONVERSATION_METRIC_VALUE_TYPE = {
  STRING: "string",
  FLOAT: "float",
} as const

export const UPLOADED_CONVERSATION_METRIC_VALUE_TYPES = [
  UPLOADED_CONVERSATION_METRIC_VALUE_TYPE.STRING,
  UPLOADED_CONVERSATION_METRIC_VALUE_TYPE.FLOAT,
] as const

export type ConversationsMetricValueType =
  (typeof UPLOADED_CONVERSATION_METRIC_VALUE_TYPES)[number]

export const UPLOADED_CONVERSATION_METRIC_VALUE_OPERATORS = [
  ">",
  "<",
  "=",
  ">=",
  "<=",
  "exists",
] as const

export type ConversationsMetricValueOperator =
  (typeof UPLOADED_CONVERSATION_METRIC_VALUE_OPERATORS)[number]

export const DEFAULT_CONVERSATIONS_METRIC_VALUE_OPERATOR: ConversationsMetricValueOperator =
  "="

// Table column types
export interface ColumnInfo {
  key: string
  label: string
}

export interface TableColumns {
  firstColumns: ColumnInfo[]
  lastColumns: ColumnInfo[]
}

export interface ConversationsMetadataFilter {
  key: string
  value: string
  matchType?: MetadataFilter["matchType"]
  values?: string[]
}

// Metric value filter — filters calls by metric output value
export interface MetricValueFilter {
  metricId: string
  metricDisplayName: string
  operator: ConversationsMetricValueOperator
  value: string // "YES"/"NO"/"UNKNOWN" for string metrics, number-as-string for float
  valueType: ConversationsMetricValueType
}

export interface ConversationsTableFilters {
  startDate?: string
  endDate?: string
  metricIds?: string[]
  agentIds?: string[]
  tagFilters?: string[]
  projectIds?: string[]
  metadataFilters?: ConversationsMetadataFilter[]
  metricValueFilters?: MetricValueFilter[]
}
